export default __webpack_public_path__ + "media/images/icons/phone-4f0f2a0c536a34aa418664b7e095da8d.svg";